import { SagaIterator } from 'redux-saga';
import { takeEvery, takeLatest } from 'redux-saga/effects';

import {
  EditPublishedConnection,
  EnterPublishedConnectionSubspace,
  PublishedConnectionCountsRequest
} from '~src/app/actions/AppActionTypes';

import { handleEditPublishedConnection } from './EditPublishedConnectionSaga';
import { handleEnterPublishedConnectionSubspace } from './EnterPublishedConnectionSpaceSaga';
import { handlePublishedConnectionCountsRequest } from './PublishedConnectionCountsRequestSaga';

export function* rootPublishedConnectionSaga(): SagaIterator {
  yield takeEvery(EditPublishedConnection, handleEditPublishedConnection);
  yield takeLatest(EnterPublishedConnectionSubspace, handleEnterPublishedConnectionSubspace);
  yield takeLatest(PublishedConnectionCountsRequest, handlePublishedConnectionCountsRequest);
}
